module.exports = __webpack_public_path__ + "img/registro.a52b5dd0.png";